import { BaseAlertBanner, BaseDivider } from '@components';
import { DEFAULT_COLORS, TEXT_COLORS } from '@constants/colors.ts';
import { DESKTOP_SIZES, FONT_FAMILY, SIZES } from '@constants/fonts.ts';
import { ModalButtonsWrapper as ButtonsWrapper } from '@routes/___shared___/styled.tsx';
import styled from 'styled-components';

export const modalForceStyles = {
    mask: {
        backdropFilter: 'blur(4px)',
        background: 'rgba(112, 118, 141, 0.40)',
    },
};

export const ConsentCenterListContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 1 0 0;
    align-self: stretch;
`;

export const ConsentCenterItemRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const ListContainer = styled.div<{ isBigScreen: boolean }>`
    width: ${({ isBigScreen }) => (isBigScreen ? '50rem' : '100%')};
`;

export const ConsentCenterDescWrapper = styled.div`
    color: ${TEXT_COLORS.body};
    ${FONT_FAMILY.poppins};
    ${DESKTOP_SIZES[SIZES.BODY_SM_MED].fontSize};
    ${DESKTOP_SIZES[SIZES.BODY_SM_MED].fontWeight};
    ${DESKTOP_SIZES[SIZES.BODY_SM_MED].lineHeight};
`;

export const ConsentCenterDescDateWrapper = styled.div`
    color: ${TEXT_COLORS.disabledGray};
    ${FONT_FAMILY.poppins};
    ${DESKTOP_SIZES[SIZES.BODY_XS].fontSize};
    ${DESKTOP_SIZES[SIZES.BODY_XS].fontWeight};
    ${DESKTOP_SIZES[SIZES.BODY_XS].lineHeight};
`;

export const BaseAlertBannerWrapper = styled(BaseAlertBanner)`
    margin: 24px 0 16px;
`;

export const BaseAlertBannerDesc = styled.div`
    color: ${TEXT_COLORS.body};
    ${FONT_FAMILY.poppins};
    ${DESKTOP_SIZES[SIZES.BODY_SM].fontSize};
    ${DESKTOP_SIZES[SIZES.BODY_SM].fontWeight};
    ${DESKTOP_SIZES[SIZES.BODY_SM].lineHeight};
`;

// delete consents section
export const UserDataDeleteTitle = styled.div`
    color: ${TEXT_COLORS.heading};
    ${FONT_FAMILY.poppins};
    ${DESKTOP_SIZES[SIZES.HEADING_XS].fontSize};
    ${DESKTOP_SIZES[SIZES.HEADING_XS].fontWeight};
    ${DESKTOP_SIZES[SIZES.HEADING_XS].lineHeight};
    margin-right: 4px;
`;

export const UserDataDeleteDesc = styled.div<{ $isDataDeletionRequestSubmitted: boolean }>`
    color: ${TEXT_COLORS.body};
    ${FONT_FAMILY.poppins};
    ${DESKTOP_SIZES[SIZES.BODY_SM_MED].fontSize};
    ${DESKTOP_SIZES[SIZES.BODY_SM_MED].fontWeight};
    ${DESKTOP_SIZES[SIZES.BODY_SM_MED].lineHeight};
    padding-bottom: ${({ $isDataDeletionRequestSubmitted }) => ($isDataDeletionRequestSubmitted ? '0' : '16px')};
`;

export const DeleteButtonTitle = styled.div<{ $isDataDeletionRequestSubmitted: boolean }>`
    color: ${({ $isDataDeletionRequestSubmitted }) =>
        $isDataDeletionRequestSubmitted ? `${TEXT_COLORS.disabled}` : `${TEXT_COLORS.action}`};
    ${FONT_FAMILY.poppins};
    ${DESKTOP_SIZES[SIZES.BODY_SM_MED].fontSize};
    ${DESKTOP_SIZES[SIZES.BODY_SM_MED].fontWeight};
    ${DESKTOP_SIZES[SIZES.BODY_SM_MED].lineHeight};
`;

export const DeleteSection = styled.div`
    padding-top: 24px;
`;

export const BaseDividerWrapper = styled(BaseDivider)`
    margin: 0;
`;

// id used here because there were problems with passing custom props to styled(BaseButton)
export const ModalButtonsWrapper = styled(ButtonsWrapper)`
    #confirm-del-btn {
        border-color: ${TEXT_COLORS.error} !important;
        color: ${TEXT_COLORS.error} !important;
        &&:hover {
            background: ${DEFAULT_COLORS.white} !important;
        }
    }
`;

export const BaseButtonTitle = styled.div`
    ${FONT_FAMILY.poppins};
    ${DESKTOP_SIZES[SIZES.BODY_SM_MED].fontSize};
    ${DESKTOP_SIZES[SIZES.BODY_SM_MED].fontWeight};
    ${DESKTOP_SIZES[SIZES.BODY_SM_MED].lineHeight};
`;
